import axiosPost from '../axiosPost';

export const endUserCuilCuitUpd = async (arg) => {
    const name = 'End User Cuil Cuit Update';
    let result;

    const { params } = arg

    const body = {
        "service": "EndUserOnboardCUILBOUpd",
        "params": params ? params : {}
    }

    try {
        result = await axiosPost('Y', body, arg)
    } catch (err) {
        console.log(err)
    }

    if (!result || result === null) {
        console.log(`Error getting ${name}`)
    }
    console.log(result.data)
    return result.data
}